<div *ngIf="!this.returns.length" style="background-color: #F5F7F8; height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;">
  <div style="text-align: center; padding: 10px;">
    <img style="z-index: 1000; width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="width: 100%; height: 22px; position: absolute; top: 20px; left: 0px; margin: auto; text-align: center;">Заявки за връщане</h2>
    <p style="font-size: 16px; font-weight: bold; margin-top: 7px;">Нямаш подадени заявки</p>
    <p style="margin-top: 7px; color: #ADAFBB;">Все още не си подал заявка за връщане на покупка.</p>
  </div>
</div>

<div *ngIf="this.returns.length" style="background-color: #F5F7F8; width: 100vw; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 7px;">
  <img style="width: 22px; height: 22px; position: relative; top: 30px; left: 15px;" (click)="this.back()" src="/assets/images/shared/back.svg">
  <h2 style="text-align: center; margin-top: 3px;">Заявки за връщане</h2>

  <div style="overflow-y: scroll; background-color: #F5F7F8;">
    <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;" *ngFor="let returnInfo of this.returns">
      <p>
        <span style="color: #ADAFBB; width: 50%; display: inline-block;">{{ this.date(returnInfo.updated_at) }}</span>
        <span style="display: inline-block; color: #ADAFBB; width: 50%; text-align: right;">{{ this.time(returnInfo.updated_at) }}</span>
      </p>

      <div *ngFor="let productPerOrg of returnInfo.fullOrder!.data.returnedCartLines">
        <div style="height: 170px; width: 100%;">
          <div style="height: 130px; margin: 0px; margin-top: 10px;" class="row">
            <label style="width: 100px; height: 110px; padding: 3px; border: 1px solid #EDF5FC; border-radius: 10px; margin-top: 10px; vertical-align: unset;" [for]="productPerOrg.uuid">
              <img style="width: 90px; height: 100px; vertical-align: unset;" [src]="productPerOrg.imageSource" alt="">
            </label>

            <div class="col-7 product" style="display: inline-block; margin-top: 10px; flex: 0 0 65%; max-width: 65%;">
              <p (click)="this.goToProduct(productPerOrg)" style="font-size: 13px; font-weight: bold; margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; height: 40px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-top: 5px;">
                {{ productPerOrg.sku?.product?.name }}
              </p>

              <p style="font-size: 10px; color: #0A69EB; margin-bottom: 3px;">
                Статус:
                <span [class]="this.getStatusClass(returnInfo.state)">{{ this.returnStatusTranslation(returnInfo.state) }}</span>
              </p>

              <p *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;">
                <span *ngFor="let option of productPerOrg.sku?.options || []; index as i">
                  {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '') }}
                </span>
              </p>

              <p *ngIf="!productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>

              <div style="min-width: 170px;" *ngIf="productPerOrg.sku">
                <div class="return-item-row">
                  <div class="return-item-info">
                    <app-price
                      class="return-line-total-price"
                      [amount]="getLineTotalBase(productPerOrg, returnInfo, productPerOrg.uuid)"
                      layout="inline"
                    ></app-price>

                    <div class="return-item-subprice">
                      <span class="return-line-mult">
                        {{ pricingInfoText(returnInfo, productPerOrg.uuid) }}
                      </span>
                      <app-price
                        class="return-line-unit-price"
                        [amount]="getUnitPriceBase(productPerOrg)"
                        layout="inline"
                      ></app-price>
                    </div>
                  </div>

                  <div class="return-item-qty">
                    <span>Брой: {{ this.returnReturnQuantityForProduct(returnInfo, productPerOrg.uuid) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
          </div>
        </div>
      </div>

      <div class="row justify-content-around;" style="margin-top: 20px;">
        <button
          type="button"
          class="btn btn-primary col-10"
          style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB; border: none;"
          (click)="this.goToReturnDetails(returnInfo)"
        >
          Виж детайли
        </button>
      </div>
    </div>
  </div>
</div>
